export enum ChromePrintStatus {
    USER_REJECTED = 'CHROME-PRINT-JOB-FINISHED-USER-REJECTED',
    TIMEOUT = 'WEB-PRINT-CHROME-ENV-TIMEOUT',
    FAILED = 'CHROME-PRINT-JOB-FAILED',
    PRINTER_NOT_FOUND = 'CHROME-NO-FOUND-SPECIFIC-PRINTER-NAME',
    UNSPECIFIED_JOB = 'CHROME-NO-PRINT-JOB-INFO-FOUND-IN-REQUEST',
    NO_CHROMEBOX = 'WEB-CHROME-ENV-NOT-AVAILABLE',
    SUBMIT_JOB_REQUEST_OK = 'CHROME-PRINT-JOB-FINISHED-OK',
    PENDING_PRINT = 'CHROME-PENDING-PRINT',
    PRINT_IN_PROGRESS = 'CHROME-PRINT-IN-PROGRESS',
    PRINT_CANCELED = 'CHROME-PRINT-CANCELED',
    PRINT_FAILED = 'CHROME-PRINT-FAILED',
    PRINTED = 'CHROME-PRINTED',
    CANCEL_PRINT_FAILED = 'CHROME-CANCEL-PRINT-FAILED'
}
